<div mat-dialog-title>
    <span>{{'action.configuration' | translate}}</span>
    <button  [mat-dialog-close]="data">
        <i class="fa fa-times"></i>
    </button>
</div>

<mat-dialog-content>
    <div class="">
        <h3>{{'vnf_dashboard.modal.configuration.import' | translate}}</h3>

        <div class="wrap-file-actions">
            <!-- <app-file-download (userWantsDownloadEvent)="onUserWantsDownloadVnfDashboardEvent($event)" [backendResponse]="backendResponseDownloadedFileVnfDashboard"></app-file-download> -->
            <!-- <app-file-upload appReadWrite (userWantsUploadEvent)="onUserWantsUploadVnfDashboardEvent($event)" [backendResponse]="backendResponseUploadedFileVnfDashboard"></app-file-upload> -->
            <app-file-upload (userWantsUploadEvent)="onUserWantsUploadVnfDashboardEvent($event)" [backendResponse]="backendResponseUploadedFileVnfDashboard"></app-file-upload>

        </div>
    </div>
</mat-dialog-content>